module.exports = __webpack_public_path__ + "static/media/bittrex-dark.7f353bc0.svg";